<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>学习建议</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="年龄档">
              <Select v-model="queryParam.ageBand" clearable placeholder="请选择年龄档">
                <Option value="LOW">低档 LOW（3-5）</Option>
                <Option value="MID">中档 MID（6-8）</Option>
                <Option value="HIGH">高档 HIGH（9+）</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="技能">
              <Select v-model="queryParam.skill" clearable placeholder="请选择技能">
                <Option value="Listening">听力 Listening</Option>
                <Option value="Speaking">口语 Speaking</Option>
                <Option value="Reading">阅读 Reading</Option>
                <Option value="Writing">写作 Writing</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="分数档">
              <Select v-model="queryParam.scoreBand" clearable placeholder="请选择分数档">
                <Option value="LOW">低档 LOW</Option>
                <Option value="MID">中档 MID</Option>
                <Option value="HIGH">高档 HIGH</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="状态">
              <Select v-model="queryParam.status" clearable placeholder="请选择状态">
                <Option value="ONLINE">已上线 ONLINE</Option>
                <Option value="OFFLINE">已下线 OFFLINE</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
          <Button type="success" @click="openCreate">新建</Button>
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/advice/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
    <Modal v-model="editVisible" :title="form.id ? '编辑学习建议' : '新建学习建议'" width="760">
      <div style="max-height:70vh;overflow-y:auto;padding-right:8px">
        <Form :label-width="90">
          <Row :gutter="12">
            <i-col :span="8">
              <Form-item label="年龄档">
                <Select v-model="form.ageBand">
                  <Option value="LOW">低档 LOW（3-5）</Option>
                  <Option value="MID">中档 MID（6-8）</Option>
                  <Option value="HIGH">高档 HIGH（9+）</Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col :span="8">
              <Form-item label="技能">
                <Select v-model="form.skill">
                  <Option value="Listening">听力 Listening</Option>
                  <Option value="Speaking">口语 Speaking</Option>
                  <Option value="Reading">阅读 Reading</Option>
                  <Option value="Writing">写作 Writing</Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col :span="8">
              <Form-item label="分数档">
                <Select v-model="form.scoreBand">
                  <Option value="LOW">低档 LOW</Option>
                  <Option value="MID">中档 MID</Option>
                  <Option value="HIGH">高档 HIGH</Option>
                </Select>
              </Form-item>
            </i-col>
          </Row>
          <Form-item label="状态">
            <Select v-model="form.status">
              <Option value="ONLINE">已上线 ONLINE</Option>
              <Option value="OFFLINE">已下线 OFFLINE</Option>
            </Select>
          </Form-item>
          <Form-item label="文案">
            <Input v-model="form.content" type="textarea" :rows="6" placeholder="给该年龄档、技能、分数档的学习建议正文"></Input>
          </Form-item>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" @click="save">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'MexAdviceList',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {},
      form: {},
      tableColumns: [
        { title: 'ID', key: 'id', width: 80, ellipsis: true },
        { title: '年龄档', key: 'ageBand', width: 150, ellipsis: true, render: (h, params) => h('span', this.ageBandLabel(params.row.ageBand)) },
        { title: '技能', key: 'skill', width: 140, ellipsis: true, render: (h, params) => h('span', this.skillLabel(params.row.skill)) },
        { title: '分数档', key: 'scoreBand', width: 110, ellipsis: true, render: (h, params) => h('span', this.scoreBandLabel(params.row.scoreBand)) },
        { title: '状态', key: 'status', width: 140, ellipsis: true, render: (h, params) => h('span', this.statusLabel(params.row.status)) },
        { title: '文案', key: 'content', width: 420, ellipsis: true },
        {
          title: '操作',
          key: 'action',
          width: 240,
          render: (h, params) => {
            return h('div', { style: { whiteSpace: 'nowrap' } }, [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openEdit(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.changeStatus(params.row.id, 'online') }
              }, '上线'),
              h('Button', {
                props: { size: 'small' },
                on: { click: () => this.changeStatus(params.row.id, 'offline') }
              }, '下线')
            ])
          }
        }
      ]
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    statusLabel (code) {
      if (code === 'ONLINE') return '已上线 ONLINE'
      if (code === 'OFFLINE') return '已下线 OFFLINE'
      return code || ''
    },
    skillLabel (code) {
      if (code === 'Listening') return '听力 Listening'
      if (code === 'Speaking') return '口语 Speaking'
      if (code === 'Reading') return '阅读 Reading'
      if (code === 'Writing') return '写作 Writing'
      return code || ''
    },
    ageBandLabel (code) {
      if (code === 'LOW') return '低档 LOW（3-5）'
      if (code === 'MID') return '中档 MID（6-8）'
      if (code === 'HIGH') return '高档 HIGH（9+）'
      return code || ''
    },
    scoreBandLabel (code) {
      if (code === 'LOW') return '低档 LOW'
      if (code === 'MID') return '中档 MID'
      if (code === 'HIGH') return '高档 HIGH'
      return code || ''
    },
    emptyForm () {
      return {
        ageBand: 'MID',
        skill: 'Listening',
        scoreBand: 'LOW',
        content: '',
        status: 'ONLINE'
      }
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    openCreate () {
      this.form = this.emptyForm()
      this.editVisible = true
    },
    openEdit (row) {
      this.form = {
        id: row.id,
        ageBand: row.ageBand,
        skill: row.skill,
        scoreBand: row.scoreBand,
        content: row.content,
        status: row.status
      }
      this.editVisible = true
    },
    save () {
      this.$http.post('/mex/advice/save', this.form).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(this.form.id ? '已更新' : '已新建')
          this.editVisible = false
          this.search()
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    changeStatus (id, action) {
      this.$http.post('/mex/advice/' + action, { id: id }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';
</style>



// WEBPACK FOOTER //
// MexAdviceList.vue?b638bae0